import getQuestaoInternaFromApi from './getQuestaoInternaFromApi';

const pvNormalizarQuestao = pQuestao => {
  const xSessaoId = String(pQuestao?.avaliacao_secao_id || '');
  const xQuestaoId = Number(pQuestao?.avaliacao_questao_id);

  if (!xSessaoId || !Number.isFinite(xQuestaoId) || xQuestaoId <= 0) {
    return null;
  }

  return {
    id: xQuestaoId,
    questao: pQuestao?.avaliacao_questao || '',
    tooltip: pQuestao?.avaliacao_questao_tooltip || '',
    resposta_tipo: pQuestao?.resposta_tipo || null,
    resposta_dominio: Array.isArray(pQuestao?.resposta_dominio) ? pQuestao.resposta_dominio : [],
    interna: getQuestaoInternaFromApi(pQuestao),
    sessao_descricao: pQuestao?.avaliacao_secao_descricao || '',
    sessao_tooltip: pQuestao?.avaliacao_secao_tooltip || '',
    sessao_id: xSessaoId,
    sessao: pQuestao?.avaliacao_secao_sigla || '',
    sessao_label: pQuestao?.avaliacao_secao || ''
  };
};

const pvOrdenarQuestoes = pQuestoes => {
  return [...pQuestoes].sort((pQuestaoA, pQuestaoB) => {
    const xSessaoA = Number(pQuestaoA?.avaliacao_secao_id) || 0;
    const xSessaoB = Number(pQuestaoB?.avaliacao_secao_id) || 0;

    if (xSessaoA !== xSessaoB) {
      return xSessaoA - xSessaoB;
    }

    const xQuestaoA = Number(pQuestaoA?.avaliacao_questao_id) || 0;
    const xQuestaoB = Number(pQuestaoB?.avaliacao_questao_id) || 0;

    return xQuestaoA - xQuestaoB;
  });
};

const pvMontarSessoes = pQuestoes => {
  return pQuestoes.reduce((pAcc, pQuestao) => {
    if (!pQuestao) {
      return pAcc;
    }

    const xSessaoId = pQuestao.sessao_id;

    if (!pAcc[xSessaoId]) {
      pAcc[xSessaoId] = {
        id: xSessaoId,
        label: pQuestao.sessao_label || '',
        sessao: pQuestao.sessao || '',
        progression: 0,
        completed: false
      };
    }

    return pAcc;
  }, {});
};

const pvMontarSessoesQuestoes = pQuestoes => {
  return pQuestoes.reduce((pAcc, pQuestao) => {
    if (!pQuestao) {
      return pAcc;
    }

    if (!pAcc[pQuestao.sessao_id]) {
      pAcc[pQuestao.sessao_id] = {
        questoes: []
      };
    }

    pAcc[pQuestao.sessao_id].questoes.push(pQuestao);
    return pAcc;
  }, {});
};

const pvMontarQuestoesById = pQuestoes => {
  return pQuestoes.reduce((pAcc, pQuestao) => {
    if (!pQuestao) {
      return pAcc;
    }

    pAcc[pQuestao.id] = pQuestao;
    return pAcc;
  }, {});
};

const hydrateAvaliacaoQuestoes = (pAvaliacao, pQuestoesModelo) => {
  const xQuestoesModelo = Array.isArray(pQuestoesModelo)
    ? pvOrdenarQuestoes(pQuestoesModelo).map(pvNormalizarQuestao).filter(Boolean)
    : [];

  return {
    avaliacao: pAvaliacao || null,
    modeloQuestoes: xQuestoesModelo,
    questoes: xQuestoesModelo,
    questoesById: pvMontarQuestoesById(xQuestoesModelo),
    sessoes: pvMontarSessoes(xQuestoesModelo),
    sessoesQuestoes: pvMontarSessoesQuestoes(xQuestoesModelo)
  };
};

export default hydrateAvaliacaoQuestoes;
